import { ChevronLeft, ChevronRight } from "lucide-react";
import GeneratePaginationLinks from "./GeneratePaginationLinks";
import { Button } from "./ui/button";
import { Pagination, PaginationContent, PaginationItem } from "./ui/pagination";
import { Separator } from "./ui/separator";
import { useLocation } from "react-router";
import { Input } from "./ui/input";
import { useState } from "react";
import { set } from "lodash";

type CustomPagination = {
  currentPage: number;
  totalPages: number;
  onPageChange: (pageNumber: number) => void;
  showPreviousNext: boolean;
  table: unknown;
  meta: {
    take: number;
    page: number;
    itemCount: number;
  };
};

const CustomPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  showPreviousNext,
  table,
  meta,
}: CustomPagination) => {
  const location = useLocation()?.pathname;
  const [inputPage, setInputPage] = useState("");
  const goToPage=()=>{
    const page = Number(inputPage);
    if(!isNaN(page) && page >= 1 && page <= totalPages){
      onPageChange(page);
      setInputPage("");
    }
  }
  console.log(totalPages)
  return (
    <div className="flex items-center justify-between p-4 border-t w-full">
      {/* {location?.includes("transactions") || location?.includes("users/") ? (
        <div></div>
      ) : (
        <div className="flex-1 text-sm text-muted-foreground">
          {table?.getFilteredSelectedRowModel().rows.length} of{" "}
          {table?.getFilteredRowModel().rows.length} row(s) selected.
        </div>
      )} */}
      {/* <div className="flex gap-4  justify-between"> */}
        <p className="flex items-center justify-center text-sm font-medium w-2xl ">
          Showing {meta?.page * meta?.take - meta?.take + 1} to{" "}
          {meta?.page * meta?.take > meta?.itemCount
            ? meta?.itemCount
            : meta?.page * meta?.take}{" "}
          of {meta?.itemCount}
        </p>
      <div className="flex gap-4  justify-end">
        {/* <div> */}
        <Pagination>
          <PaginationContent>
                <PaginationItem>
                  <div className="flex items-center gap-2">
<Input
type="number"
className="w-16 h-9 px-2"
min={1}
max={totalPages}
value={inputPage}
onChange={(e) => setInputPage(e.target.value)}
/>
                  <Button
                  size="sm"
                  variant='default'

                    // className="w-8 h-8 p-0 rounded-r-none cursor-pointer bg-off-white-2 text-gray hover:bg-inherit"
                    onClick={goToPage}
                    disabled={!inputPage}
                  >
                   Jump to page
                  </Button>
                  </div>
                </PaginationItem> 
            {GeneratePaginationLinks(currentPage, totalPages, onPageChange)}
            <div className="flex items-center">
              {showPreviousNext && totalPages ? (
                <PaginationItem>
                  <Button
                    className="w-8 h-8 p-0 rounded-r-none cursor-pointer bg-off-white-2 text-gray hover:bg-inherit"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage - 1 < 1 ? true : false}
                  >
                    <ChevronLeft />
                  </Button>
                </PaginationItem>
              ) : null}
              <Separator orientation="vertical" className="h-8" />
              {showPreviousNext && totalPages ? (
                <PaginationItem>
                  <Button
                    className="w-8 h-8 p-0 rounded-l-none cursor-pointer bg-off-white-2 text-gray hover:bg-inherit"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage > totalPages - 1 ? true : false}
                  >
                    <ChevronRight />
                  </Button>
                </PaginationItem>
              ) : null}
            </div>
          </PaginationContent>
        </Pagination>
        {/* </div> */}
      </div>
    </div>
  );
};

export default CustomPagination;
